import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import checkboxIndeterminateMixin from "../mixins/checkbox-indeterminate";
import Axios from 'axios';
export default {
  name: "group-modal",
  props: ["title", "from", "group", "value"],
  mixins: [formValidateMixin, ModalMixin, checkboxIndeterminateMixin],
  data: function data() {
    return {
      data: {
        id: "",
        name: "",
        permissions: [],
        max_point_num: 1,
        max_trial_days: 1,
        all_products: 0,
        productdetails: []
      },
      rules: {
        name: {
          type: "string",
          required: true,
          min: 2,
          max: 20
        },
        permissions: {
          type: "array",
          min: 1,
          required: true
        }
      },
      loading: false,
      allPermissions: [],
      allProducts: [],
      showProducts: [],
      searchProdText: '',
      preSearchProdText: ''
    };
  },
  methods: {
    onCheckedChange: function onCheckedChange() {
      var _this = this;
      this.checkAllGroup.splice(0);
      this.allProducts.forEach(function (item) {
        item._checked && _this.checkAllGroup.push(item.value);
      });
      this.getCheckAllStatus();
    },
    onSearchProdTextChange: function onSearchProdTextChange() {
      var _this2 = this;
      var keyword = this.searchProdText;
      keyword = keyword || '';
      keyword = keyword.trim().toLowerCase();
      if (keyword === this.preSearchProdText) {
        return false;
      }
      this.preSearchProdText = keyword;
      this.showProducts.splice(0);
      this.allProducts.map(function (item) {
        var value = item.label.toLowerCase();
        if (keyword === '' || value.indexOf(keyword) > -1) {
          _this2.showProducts.push(item);
        }
      });
    },
    onLoad: function onLoad() {
      var _this3 = this;
      this.validate();
      if (this.group && this.from === "update") {
        this.data.id = this.group.id;
        this.data.name = this.group.name;
        this.data.permissions = this.group.permissions.map(function (x) {
          return x.id;
        });
        this.data.max_point_num = this.group.max_point_num;
        this.data.max_trial_days = this.group.max_trial_days;
        this.data.all_products = this.group.all_products ? 1 : 0;
        this.data.productdetails = this.group.productdetails.map(function (x) {
          return x.id;
        });
        this.validate();
        this.checkAllGroup.splice(0);
        this.data.productdetails.forEach(function (id) {
          _this3.checkAllGroup.push(id);
        });
      }
      Axios.get("users/permissions/").then(function (resp) {
        _this3.allPermissions = resp.data.permissions;
      });
      Axios.get('fenxiang/product-details/?pagination=false').then(function (resp) {
        var _resp$data = resp.data,
          code = _resp$data.code,
          list = _resp$data.productdetails;
        if (code !== 0) {
          return false;
        }
        if (!Array.isArray(list)) {
          return false;
        }
        list.forEach(function (item) {
          var o = {
            value: item.id,
            label: item.product_name,
            _checked: false
          };
          if (_this3.checkAllGroup.indexOf(o.value) > -1) {
            o._checked = true;
          }
          _this3.allProducts.push(o);
          _this3.checkboxData.push(o);
          _this3.showProducts.push(o);
        });
        _this3.getCheckAllStatus();
      });
    },
    handleOk: function handleOk() {
      var _this4 = this;
      var data = this.data;
      var _this$data = this.data,
        max_point_num = _this$data.max_point_num,
        max_trial_days = _this$data.max_trial_days;
      // 万恶的表单校验之数字
      max_point_num = parseInt(max_point_num);
      max_trial_days = parseInt(max_trial_days);
      if (isNaN(max_point_num) || max_point_num < 0) {
        this.$Message.error('最大试用点数必须是不小于1的正整数!');
        return;
      }
      if (isNaN(max_trial_days) || max_trial_days < 0) {
        this.$Message.error('最大试用天数必须是不小于1的正整数!');
        return;
      }
      var params = {
        name: data.name,
        max_point_num: max_point_num,
        max_trial_days: max_trial_days,
        permissions: data.permissions
      };
      if (this.data.all_products === 1) {
        params.all_products = true;
      } else {
        params.all_products = false;
        params.productdetails = this.checkAllGroup;
      }
      var url = "users/groups/";
      var method = 'post';
      if (this.from === "update") {
        url = "users/groups/".concat(this.data.id, "/");
        method = 'put';
      }
      this.loading = true;
      return Axios({
        method: method,
        url: url,
        data: params
      }).then(function () {}).catch(function (e) {
        throw e;
      }).finally(function () {
        _this4.loading = false;
      });
    },
    resetData: function resetData() {
      this.data.name = "";
      this.data.permissions.splice(0);
      this.data.all_products = 0;
      this.data.productdetails.splice(0);
      this.allPermissions.splice(0);
      this.allProducts.splice(0);
      this.searchProdText = '';
      this.preSearchProdText = '';
      this.checkboxData.splice(0);
      this.showProducts.splice(0);
      this.checkAllGroup.splice(0);
      this.getCheckAllStatus();
      this.$refs.form.resetFields();
      this.loading = false;
      // this.isFormValid = false;
    }
  }
};